import { accountSearchColumns, customerSearchColumns } from '@/constants/search-columns';
import { SearchField } from '@/components/custom/erp';
import { KhachHang, TaiKhoan } from '@/types/schemas';
import { Label } from '@/components/ui/label';
import { QUERY_KEYS } from '@/constants';

interface DetailsTabProps {
  searchFieldStates: {
    customer: KhachHang | null;
    setCustomer: (customer: KhachHang | null) => void;
    account: TaiKhoan | null;
    setAccount: (account: TaiKhoan | null) => void;
  };
}

const DetailsTab: React.FC<DetailsTabProps> = ({ searchFieldStates }) => {
  return (
    <div className='min-w-[900px] space-y-2 p-4'>
      <div className='flex flex-col space-y-1'>
        <div className='flex items-center'>
          <Label className='w-40 min-w-40'>Mã đối tượng</Label>
          <SearchField<KhachHang>
            type='text'
            columnDisplay={'customer_code'}
            displayRelatedField={'customer_name'}
            searchEndpoint={`/${QUERY_KEYS.KHACH_HANG}`}
            searchColumns={customerSearchColumns}
            value={searchFieldStates.customer?.customer_code}
            relatedFieldValue={searchFieldStates.customer?.customer_name}
            onRowSelection={searchFieldStates.setCustomer}
          />
        </div>

        {/* 3. Khu vực */}
        <div className='flex items-center'>
          <Label className='w-40 min-w-40'>Tài khoản</Label>
          <SearchField<TaiKhoan>
            type='text'
            columnDisplay={'code'}
            displayRelatedField={'name'}
            searchEndpoint={`/${QUERY_KEYS.TAI_KHOAN}`}
            searchColumns={accountSearchColumns}
            value={searchFieldStates.account?.code}
            relatedFieldValue={searchFieldStates.account?.name}
            onRowSelection={searchFieldStates.setAccount}
          />
        </div>
      </div>
    </div>
  );
};

export default DetailsTab;
